export default `
  query getProductFiltersByCategory($search: String = "", $filter: ProductAttributeFilterInput) {
    products(search: $search, filter: $filter) {
      aggregations {
        label
        count
        attribute_code
        options {
          count
          label
          value
          __typename
        }
        position
        __typename
      }
      __typename
    }
  }
`;